import type { SignInRequired } from '@/lib/types/auth.types';

/**
 * Narrow an email-verification outcome (signup or invite accept): true when
 * 2FA is on and the user must sign in next to set up their authenticator
 * instead of receiving a session (MYN-241). Pure.
 */
export function isSignInRequired<T extends object>(outcome: T | SignInRequired): outcome is SignInRequired {
  return 'signInRequired' in outcome && outcome.signInRequired === true;
}
